module.exports = __webpack_public_path__ + "static/media/email-icon-regular.fda69d58.png";